var _defs, _use, _use2, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.5,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-5.8%",
    y: "-4.2%",
    width: "111.7%",
    height: "111.7%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.199473505 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 15,
    cy: 15,
    r: 15
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#c)",
    style: {
      mixBlendMode: "soft-light"
    },
    xlinkHref: "#b"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    strokeOpacity: 0.097,
    stroke: "#000",
    strokeLinejoin: "square",
    cx: 15,
    cy: 15,
    r: 14.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.13 8.292l-2.4 1.224-11.598 5.907A6.909 6.909 0 0119.35 8.498l1.374-.7.205-.105a8.439 8.439 0 00-13.371 7.472 1.535 1.535 0 01-.834 1.484l-.725.37v1.724l2.134-1.088.691-.353.681-.347 12.226-6.23 1.374-.699 2.84-1.447V6.856L23.13 8.292zm2.816 2.012L10.201 18.32l-1.374.7L6 20.463v1.723l2.808-1.43 2.401-1.224 11.61-5.916a6.909 6.909 0 01-10.229 6.93l-.085.045-1.49.76a8.439 8.439 0 0013.372-7.475 1.536 1.536 0 01.833-1.483l.726-.37v-1.718z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlm);
export default __webpack_public_path__ + "static/media/xlm.8e72da3e7b3e213cb627eea19563ca91.svg";
export { ForwardRef as ReactComponent };